import type { NuxtUiTheme } from '../types/nuxt-ui-theme';

export default {
    slots: {
        content:
            'p-3 contain-[layout_paint_style] outline-none! ring-0! border border-(--white-alpha-70)! ' +
            'bg-(image:--surface-date-picker-bg)! text-(--input-neumorphic-text)! shadow-(--surface-card-shadow)! ' +
            'focus:outline-none! focus:ring-0! focus-visible:outline-none! focus-visible:ring-0!'
    }
} satisfies NuxtUiTheme['popover'];
